<template>
    <container>
        <row>
            <column :md="12" :xl="6">
                <p class="text-primary">For Guests</p>
                <footer-menu>
                    <footer-menu-link to="/book-a-property">Book a Property</footer-menu-link>
                    <footer-menu-link to="/boutique-collections">Boutique Collections</footer-menu-link>
                </footer-menu>
            </column>

            <column :md="12" :xl="6">
                <p class="text-primary">For Owners</p>
                <footer-menu>
                    <footer-menu-link to="/list-your-property">Rent Your Home</footer-menu-link>
                    <footer-menu-link to="/property-management">Manage Your Home</footer-menu-link>
                    <footer-menu-link to="/real-estate">Buy a Home</footer-menu-link>
                    <footer-menu-link to="/renovate">Renovate Your Home</footer-menu-link>
                    <footer-menu-link to="/property-analysis">Property Analysis</footer-menu-link>
                </footer-menu>
            </column>

            <column :md="12" :xl="6">
                <p class="text-primary">Other</p>
                <footer-menu>
                    <footer-menu-link to="/about">About Us</footer-menu-link>
                    <footer-menu-link to="/blog">Blog</footer-menu-link>
                    <footer-menu-link to="/press">Press</footer-menu-link>
                    <footer-menu-link to="/careers">Employment</footer-menu-link>
                    <footer-menu-link to="/terms">Legal</footer-menu-link>
                    <footer-menu-link to="/compliance">Compliance</footer-menu-link>
                    <footer-menu-link to="/collateral">Collateral</footer-menu-link>
                    <footer-menu-link to="/contact">Contact Us</footer-menu-link>
                </footer-menu>
            </column>

            <column :md="12" :xl="6">
                <div class="mb-5 mb-md-5 mb-lg-3 ms-auto">
                    <router-link to="/" class="d-block text-decoration-none mb-3 text-primary" style="max-width:150px;" aria-label="StayMarquis Home Page">
                        <logo/>
                    </router-link>

                    <template v-if="uiStore.siteName == 'thedrakeinn'">
                        <address class="mb-3">
                            16 Penny Lane<br />
                            Hampton Bays, NY 11946
                        </address>
                        <p>
                            <a href="mailto:hello@thedrakeinn.com">hello@thedrakeinn.com</a>
                        </p>
                    </template>
                    
                    <template v-else>
                        <address class="mb-3">
                            {{ officeAddress }}<br />
                            {{ officeCity }}, {{ officeState }} {{ officeZip }}
                        </address>

                        <p>
                            <a href="mailto:info@staymarquis.com">info@staymarquis.com</a>
                        </p>

                        <social-media-icons/>
                    </template>
                </div>
            </column>
        </row>
    </container>
</template>

<script type="text/javascript">
    import Logo from '@/components/Layout/Logo.vue';
    import FooterMenu from '@/components/Layout/Footer/Menu.vue';
    import FooterMenuLink from '@/components/Layout/Footer/MenuLink.vue';
    import SocialMediaIcons from "@/components/Content/SocialMediaIcons.vue";
    import CommonComponents from '@/components/Common.vue';

    import MapsConfig from '@/config/maps.json';

    import { UseUIStore } from '@/store/UI.js';

    export default {

        components: {
            Logo,
            FooterMenu,
            FooterMenuLink,
            SocialMediaIcons,
            ...CommonComponents,
        },

        setup() {
            return {
                uiStore: UseUIStore(),
            };
        },

        data() {
            return {
                officeAddress: MapsConfig.offices[0].streetAddress,
                officeCity: MapsConfig.offices[0].city,
                officeState: MapsConfig.offices[0].state,
                officeZip: MapsConfig.offices[0].zip,
            };
        },
        
    };

</script>
